'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Level = require('./Level');

var _Level2 = _interopRequireDefault(_Level);

var _Connections = require('./Connections');

var _Connections2 = _interopRequireDefault(_Connections);

var _selectors = require('../selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JobCareerMap(_ref) {
  var moduleClass = _ref.moduleClass,
      levels = _ref.levels,
      connections = _ref.connections,
      positions = _ref.positions,
      _getPosition = _ref.getPosition;

  return _react2.default.createElement(
    'div',
    {
      id: 'tab-job-map',
      className: 'tab-content type-job_career_map ' + moduleClass
    },
    _react2.default.createElement(
      'div',
      { className: 'job-map' },
      _react2.default.createElement(
        'div',
        { className: 'map', id: 'job-map-container' },
        _react2.default.createElement(_Connections2.default, {
          positions: positions,
          connections: connections
        }),
        levels.map(function (_ref2, key) {
          var title = _ref2.title,
              _class = _ref2._class,
              data = _ref2.data,
              level = _ref2.level;
          return _react2.default.createElement(_Level2.default, {
            key: key,
            title: title,
            _class: _class,
            data: data,
            getPosition: function getPosition(column, index, position) {
              _getPosition(level, column, index, position);
            }
          });
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'map-legend' },
        _react2.default.createElement(
          'div',
          { className: 'different' },
          _react2.default.createElement(
            'span',
            null,
            'Different Sector'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'same' },
          _react2.default.createElement(
            'span',
            null,
            'Same Sector'
          )
        )
      )
    )
  );
} /*
  */

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(JobCareerMap);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/components/JobCareerMap.jsx
// module id = 1173
// module chunks = 0